/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/
const RECAPTCHA_FORM_CONFIG_FIELDS = `
    is_enabled
    configurations {
      website_key
      badge_position
      language_code
      minimum_score
      re_captcha_type
      technical_failure_message
      validation_failure_message
      theme
    }`;

export const buildRecaptchaFormConfigQuery = (
  formTypes: string[]
): string => {
  const queries = formTypes
    .map(
      (formType) =>
        `  ${formType}: recaptchaFormConfig(formType: ${formType}) {${RECAPTCHA_FORM_CONFIG_FIELDS}
  }`
    )
    .join('\n');

  return `query {\n${queries}\n}`;
};
